module.exports = __webpack_public_path__ + "d01061633588578831ba834d2cf3ccd7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/interior1.png
// module id = 1045
// module chunks = 0